export const AUDITS_QUERY_KEY = 'audits';
